<app-clients-search [(display)]="searchDisplay" (selectedIds)="onSearchClientId($event)"></app-clients-search>
<div class="field">
  <label *ngIf="showLabel" for="CompanySelectorDd" class="do-not-wrap-text">
    {{labelKey}} ({{selectedID}})
    <span *ngIf="showTierBadge && tierBadgeText"
          class="tier-badge"
          [class.tier-badge-partner]="customerTier === 'key_partner'"
          [class.tier-badge-account]="customerTier === 'key_account'"
          [pTooltip]="tierBadgeTooltip" tooltipPosition="top">{{tierBadgeText}}</span>
  </label>
  <div class="p-inputgroup">
    <p-button icon="pi pi-external-link" styleClass="p-button-warning mr-1" (onClick)="onEditButton($event)" [disabled]="!isThereSelection"
            pTooltip="Редактировать данные об организации в новой вкладке" tooltipPosition="top" *ngIf="showEditButton"></p-button>
    <p-dropdown id="CompanySelectorDd"
                [options]="_clientslistMC"
                optionLabel="CLIENTSNIKNAME"
                [(ngModel)]="_clientMC"
                [placeholder]="placeholder"
                filterPlaceholder="Поиск..."
                [filter]="true"
                filterBy="CLIENTSNIKNAME,CLIENTNAME"
                [showClear]="true"
                [required]="true"
                [disabled]="disabled"
                [readonly]="readonly"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31"
                (onChange)="onChangeMainCompany($event)"
                (onClear)="onClearMainCompany($event)"
                class="p-dropdown-filter"
                >
    </p-dropdown>
    <p-button icon="pi pi-search" styleClass="p-button-success ml-1" (onClick)="onSearchButton($event)"
            pTooltip="Расширенный поиск организации" tooltipPosition="top" *ngIf="showSearchButton" [disabled]="disabled"></p-button>
    <p-splitButton
      *ngIf="showAddButton"
      icon="pi pi-plus"
      styleClass="p-button-success ml-1"
      [model]="addMenuItems"
      (onClick)="onAddButton($event)"
      [disabled]="disabled"
      pTooltip="Додати нову організацію (вручну; стрілка — розпізнати з тексту)"
      tooltipPosition="top">
    </p-splitButton>
  </div>
</div>

<!-- Paste-to-create dialog for AG-25 -->
<app-agent-paste-to-create
  #pasteDialog
  mode="new-company"
  [cliId]="null"
  (created)="onPasteToCreateCompleted($event)">
</app-agent-paste-to-create>
